import script from "./DownloadMail.vue?vue&type=script&setup=true&lang=ts"
export * from "./DownloadMail.vue?vue&type=script&setup=true&lang=ts"

import "./DownloadMail.vue?vue&type=style&index=0&id=53c4a041&lang=scss&scoped=true"

import exportComponent from "/home/matriXagent/git/center-secure/product/ap/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53c4a041"]])

export default __exports__